import React, { useEffect, useState } from "react";
import { Box, Button, Chip, Collapse, Stack, Typography } from "@mui/material";
import { AutomationRow, listAutomations } from "../../services/supportService";

/** Phase 2 §5.9: the automation rules and whether each is on. Read-only here; switched in Support settings (R2b-4). */
const AutomationsList: React.FC = () => {
    const [open, setOpen] = useState(false);
    const [rows, setRows] = useState<AutomationRow[] | null>(null);
    useEffect(() => { if (open && !rows) listAutomations().then((r) => setRows(r.data.automations)).catch(() => setRows([])); }, [open, rows]);

    return (
        <Box sx={{ px: 2, pb: 1 }} data-testid="automations-list">
            <Button size="small" onClick={() => setOpen((o) => !o)}>{open ? "Hide automations" : "Automations"}</Button>
            <Collapse in={open}>
                {rows?.length === 0 && <Typography variant="body2" color="text.secondary">Could not load the automations.</Typography>}
                {rows?.map((a) => (
                    <Stack key={a.key} direction="row" spacing={1} alignItems="center" sx={{ mt: 0.5 }}>
                        <Chip size="small" color={a.enabled ? "success" : "default"} label={a.enabled ? "On" : "Off"} />
                        <Typography variant="body2">{a.label}</Typography>
                        {!a.switchable && <Typography variant="caption" color="text.secondary">always on</Typography>}
                    </Stack>
                ))}
                {rows && rows.length > 0 && (
                    <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                        Switch the optional rules on or off in Customer Support → Support settings.
                    </Typography>
                )}
            </Collapse>
        </Box>
    );
};

export default AutomationsList;
